import React from 'react';
import Button from '../Button';
import Styled from './styled';
import COLORS from '../../../constants/COLORS';
import useReloadOverlay from '../../../hooks/useReloadOverlay';
import { INTERVAL_TO_TICKETS_RELOAD_MIN } from '../../../constants/INTERVALS';

const ReloadOverlay = ({ reloadMinutes = INTERVAL_TO_TICKETS_RELOAD_MIN, isVisible, toggle }) => {
  if (window.Widget.settings.previewMode) return null;
  const { t, reload } = useReloadOverlay({ reloadMinutes, toggle });

  if (!isVisible) return null;

  return (
    <Styled.Overlay>
      <Styled.Container>
        <Styled.Title>{t('ticketsOutOfDateTitle')}</Styled.Title>
        <Styled.Description>{t('marketplaceTicketsOutOfDate')}</Styled.Description>
        <Button onClick={reload} color={COLORS.MARKETPLACE_BLACK}>
          {t('marketplaceReload')}
        </Button>
      </Styled.Container>
    </Styled.Overlay>
  );
};

export default ReloadOverlay;
